<template>
  <div
    class="cursor-pointer rounded p-2 hover:bg-label/5"
    :class="{ 'bg-label/10': isActive }"
    :data-cy="`sidebar-session-${session.id}`"
  >
    <div
      v-if="session.first_message?.message"
      v-tooltipable
      class="truncate text-xs font-medium text-headline"
    >
      {{ session.first_message.message }}
    </div>
    <div v-if="subtitle" v-tooltipable class="truncate text-xs text-label">
      {{ subtitle }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { AiAgentSession } from "@/models/aiAgents";

const { session, isActive = false } = defineProps<{
  session: AiAgentSession;
  isActive?: boolean;
}>();

const subtitle = computed(() => {
  const parts = [session.agent?.name, session.application_name].filter(Boolean);
  return parts.join(" \u00B7 ");
});
</script>
